module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers/client.js
// module id = 447
// module chunks = 3